var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 236",
    d: "M22.5205 12C22.5205 17.8015 17.8264 22.5 12.0415 22.5C6.25658 22.5 1.5625 17.8015 1.5625 12C1.5625 6.19853 6.25658 1.5 12.0415 1.5C17.8264 1.5 22.5205 6.19853 22.5205 12Z",
    stroke: "black",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 57",
    d: "M26.8851 29.1158C27.4658 29.7066 28.4147 29.714 29.0045 29.1323C29.5944 28.5506 29.6018 27.6001 29.0211 27.0092L26.8851 29.1158ZM29.0211 27.0092L21.0975 18.9467L18.9615 21.0533L26.8851 29.1158L29.0211 27.0092Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3a014ae65ed195a0374751ff15459086.svg";
export { ForwardRef as ReactComponent };